import Footer from "@/components/enfinity/Footer";
import { Separator } from "@/components/ui/separator";
import { useSearchParams } from "react-router-dom";

export default function Terms() {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;
  const [searchParams] = useSearchParams();
  const serviceType = searchParams.get("service");

  const dateToday = new Date();
  const formatted = dateToday.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const isEnfinity = landingPage === "enfinity";
  const isEnfiniBoost =
    landingPage === "boost" || (isEnfinity && serviceType === "enfiniboost");
  const isEnfiniShield =
    landingPage === "shield" || (isEnfinity && serviceType === "enfinishield");
  const bgGradient = isEnfiniBoost
    ? "linear-gradient(123.341deg, rgb(96, 165, 250) 0%, rgb(76, 146, 248) 53.175%, rgb(59, 130, 246) 100%)"
    : isEnfiniShield
      ? "linear-gradient(45deg, #A78BFA, #8B5CF6)"
      : "linear-gradient(45deg,var(--primary),var(--tertiary))";

  return (
    <div
      className="space-y-12 pt-28 lg:pt-46"
      style={{ background: bgGradient }}
    >
      <div className={`bg-white rounded-2xl shadow p-8 md:p-12 w-[90%] lg:w-[70%] mx-auto ${isEnfinity ? "text-black" : ""}`}>
        <h1
          className={`text-3xl text-center font-bold ${
            isEnfiniBoost
              ? "text-[#3B82F6]"
              : isEnfiniShield
                ? "text-[#8B5CF6]"
                : isEnfinity
                  ? "text-black"
                  : "text-primary"
          }`}
        >
          Terms of Services
        </h1>
        <div className={`mt-8 space-y-5 h-[calc(100vh-350px)] overflow-auto ${isEnfinity ? "text-black" : ""}`}>
          {landingPage === "boost" || (isEnfinity && serviceType === "enfiniboost") ? (
            <>
              <h1 className="uppercase font-bold text-center text-lg">
                ENFINITY LIMITED - ENFINIBOOST USER AGREEMENT
              </h1>
              <p>
                Herein referred to as the (“Agreement”), which is by and between{" "}
                <strong>Enfinity Limited</strong>, located at{" "}
                <strong>
                  UNITS 1607-8, 16/F CITICORP CENTRE 18 WHITFIELD ROAD CAUSEWAY
                  BAY HONG KONG, HONG KONG, HONG KONG, 000000, Hong Kong SAR
                </strong>{" "}
                (“Enfinity Limited”, “we”, “us”), and the undersigned
                producer/content owner (“Producer”, “you”, “your”), ("Legal
                Name"), who is registering to the service and has agreed to the
                terms of this User Agreement, effective as of today's date{" "}
                {formatted}. This is the effective date {formatted}.
              </p>
              <Separator className="bg-black" />
              <h1 className="font-bold">1. Scope</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The purpose of this Agreement is to grant Content Licensing
                  rights to Enfinity Limited in order to legally perform its
                  services and comply with the policies in place that moderate
                  Enfinity Limited and its use of sensitive third-party tools,
                  including but not limited to: Third-party ad-feeds and
                  copyright royalty generation software that the Company uses
                  in-house or contracts out to its network of technology
                  partners, advertisers, and brands – with the ultimate goal of
                  generating new revenue royalties for you.
                </li>
                <li>
                  You still retain ownership of all your content, videos, and
                  intellectual property.
                </li>
                <li>
                  By agreeing to the terms set forth, you are allowing Enfinity
                  Limited to generate new ad-feeds, including direct and
                  embedded watch, on its various multimedia platform(s).
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">2. Content for Licensing</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The “Content” means the content produced and posted to your
                  social media channels that are being submitted upon
                  registration and submission (examples include but are not
                  limited to: YouTube, Instagram, TikTok, Facebook, Douyin,
                  Kuaishou, etc.), as well as any other content that we and you
                  agree in writing to include in this Agreement from time to
                  time.
                </li>
                <li>
                  You may deliver additional content to your point person at
                  Enfinity Limited, or by writing to copyright@enfinity.com and
                  attaching the content you desire to submit as a file or via
                  cloud storage with your provider of choice, e.g. DropBox,
                  OneDrive, etc.
                </li>
                <li>
                  At the time of this Agreement, the social video content that
                  you provided upon registration has been submitted by you to
                  Enfinity Limited for its services to be performed. Not all
                  content may be eligible, and Enfinity Limited's team will
                  review the submitted content herein to ensure third-party
                  platform compliance.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">3. Fees and Payments</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  Enfinity Limited will automatically split the revenue with the Producer in accordance with the revenue-sharing rates of this agreement. The arrangement for Ad-feed royalties (external to YouTube Monetization) shall be shared fifty percent to you and fifty percent to us. Along with this, five percent of the revenues generated will be deducted as a content hosting fee (at the moment, Dropbox Premium). Plus, an additional five percent to you (which is separate from the existing Ad-feed share) for any applicable algorithmic copyright claiming royalties, only if you opted in to this service upon registration.
                </li>
                <li>
                  Payments are sent out within 30-days of revenue generation and
                  payment made to us. For example, if you generate revenue in
                  January, you will receive your share at the end of February.
                </li>
                <li>
                  You will be responsible for taxes and reporting your revenues
                  in your own respective country, and Enfinity Limited or any of
                  its associates will not be held liable in any way in the event
                  you neglect your duties to report whatever ought to be
                  reported.
                </li>
                <li>
                  Enfinity Limited will have no obligation to pay any amounts,
                  and is permitted to deduct or withhold any amounts owed,
                  determined or reasonably suspected by Enfinity Limited, in its
                  sole discretion, to have resulted from:
                  <br />
                  (a) Action Fraud, including without limitation through any
                  clicks originating from Producer's IP addresses or computers
                  under Producer's control, solicited by payment of money, false
                  representation or request for end users to click on Ads, or
                  <br />
                  (b) fraudulent, misleading or false activities or activities
                  that Enfinity Limited believes to be fraudulent or misleading
                  or in violation of either of their respective terms of
                  service, guidelines, rules, or privacy policies.
                </li>
                <li>
                  Enfinity Limited reserves the right to withhold or deduct any
                  payments, pending Enfinity Limited’s reasonable investigation
                  of any of the foregoing or any breach of this Agreement.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">4. Contract Period</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The period of this Agreement will be for 30-days with
                  automatic renewals thereafter, unless you terminate this
                  Agreement with 30-days written notice prior to the renewal
                  date in the form of legal writing to copyright@enfinity.com.
                </li>
                <li>
                  Should you decide to end this Agreement, we agree to stop
                  pushing your new content into any new Ad-feed after the
                  termination date passes. You acknowledge and understand that
                  previously initiated content that had Ad-feeds will remain
                  active and our license in effect. This also applies for
                  Content ID claiming ONLY IF you checked the box upon
                  registration to enroll into our Content ID service.
                </li>
                <li>
                  If you choose to terminate this Agreement, we will ensure your
                  final payment is processed within 30 days of termination. By
                  ending your Agreement with Enfinity Limited or any of our
                  affiliates, you agree that no further payments will be made to
                  you after the termination date.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">
                5. Enfinity Limited’s Rights and Licenses
              </h1>
              <p>
                You hereby grant to each of the following exclusive and
                non-transferable rights:
              </p>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The legal right and license to use, reproduce, digitize,
                  encode, modify, monetize, re-format, transmit, re-broadcast,
                  repurpose the Content you submitted upon registration and
                  collect revenues from the promotion, protection, publishing,
                  and management of the Content on our multimedia platform.
                </li>
                <li>
                  The exclusive right and license to administer content
                  monetization services for the Content submitted to us across
                  various digital media platforms. You agree that we withhold
                  the right to not perform this service at any time.
                </li>
                <li>
                  The ability to sub-license the content internally or
                  externally to third-party ad-feed partners for the purpose of
                  revenue generation from your content.
                </li>
                <li>
                  [ONLY APPLIES IF YOU OPTED IN TO CONTENT ID CLAIMING] The
                  exclusive, non-transferable right to administer copyright
                  claims on your behalf on popular multimedia platforms,
                  including YouTube's Content ID system.
                </li>
                <li>
                  [ONLY APPLIES IF YOU OPTED IN TO CONTENT ID CLAIMING] The
                  ability to create an anchor account, or first account, on
                  platforms where your presence is not currently established in
                  order to prevent pirates from wrongfully uploading your
                  catalog and claiming first rights. The revenue share for this
                  is outlined as a promotional royalty in section 3.1. Royalties
                  will continue to be paid to us from anchor accounts
                  post-termination, and a buyout offer will be made to you for
                  sole ownership, typically at a multiple of twelve the gross
                  ARR we have generated on your behalf.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">6. Ownership/Clearances/Warranties</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>You retain full ownership of your Content.</li>
                <li>
                  You must have all the necessary rights and clearances in
                  connection with the Content, and you have the legal right to
                  grant the rights to us. By registering, digitally signing, and
                  submitting your Content and rights to Enfinity Limited, you
                  hereby absorb all legal liability in the event of legal
                  proceedings relating to the Content you submitted for
                  management.
                </li>
                <li>
                  You warrant and represent that the Content does not infringe
                  on the rights of any third party or violate third-party
                  platforms. Additionally, you agree to defend, indemnify and
                  hold harmless Enfinity Limited for any and all claims to the
                  contrary.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">7. Other Provisions</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  You agree to keep the terms of this Agreement confidential.
                </li>
                <li>
                  This Agreement is governed and construed according to{" "}
                  <strong>Hong Kong law</strong>, and by signing, you are
                  agreeing to submit to the jurisdiction of{" "}
                  <strong>Hong Kong</strong>.
                </li>
                <li>
                  You and Enfinity Limited waive all rights to a jury trial,
                  instead electing that the dispute be resolved by a judge.
                  Additionally, both parties agree that any and all disputes or
                  claims that have arisen or may arise between either parties
                  (Enfinity Limited and You, the "Producer"), including federal
                  and state, common law claims, and those based in contract,
                  tort, fraud, misrepresentation or any other equitable or legal
                  theory, and relating in any way to this website, its services
                  or these will be resolved only by and through confidential
                  final and binding arbitration, rather than in any court,
                  except that You may only assert claims in small claims court
                  if Your claims qualify and so long as the matter remains in
                  such court and advances only on an individual (non-class,
                  non-representative) basis.
                </li>
                <li>
                  Upon submission of acceptance of this User Agreement, I agree
                  that all information in this form is true and accurate. I also
                  agree that if I am under 18, my parent/guardian will sign this
                  User Agreement and absorb all legal liability for this User
                  Agreement.
                </li>
                <li>
                  You agree to, and are hereby bound to, our Terms of Service,
                  found here, which may be amended from time to time. Fee and
                  payment arrangements may also be amended from time-to-time.
                  Continued use of our service is constituted as acceptance to
                  such amendments. These terms include the exclusive, explicit,
                  nontransferable content licensing rights to the content
                  contractually submitted by you to Enfinity Limited. These
                  rights remain even if you terminate this Agreement, in
                  accordance with section 4 of this Agreement.
                </li>
                <li>
                  Electronic communication is a sufficient method to notify a
                  party.
                </li>
                <li>
                  By signing, you agree as follows: "I understand I am granting
                  a non-transferable, irrevocable, fully exclusive license to
                  all of the content submitted on the social media pages I am
                  submitting, and that Enfinity Limited (and any other of its
                  authorized divisions without limitation) may represent,
                  sublicense and manage this content on my behalf without
                  limitation."
                </li>
              </ol>
              <p>
                [ATTACHED UPON SIGNING AT{" "}
                <strong>https://enfiniboost.com/esign</strong>]
              </p>
              <p>
                The Content submitted by the Producer for exclusive ad-feed
                rights to Enfinity Limited, through its service known as
                Enfiniboost (and its authorized technology partners, including
                but not limited to: EnfiniBoost), was originally found on the
                links provided upon registration by the user.
              </p>
            </>
          ) : (
            <>
              <h1 className="uppercase font-bold text-center text-lg">
                ENFINITY LIMITED – ENFINISHIELD TERMS OF SERVICE
              </h1>
              <p className="text-center font-bold">
                Global Content Protection And Monetization Agreement
              </p>
              <p>
                This EnfiniShield User Agreement (herein referred to as the
                “Agreement”) is entered into by and between Enfinity Limited
                (“Enfinity Limited”, “we”, “us”), doing business as
                EnfiniShield, and the undersigned producer/content owner
                (“Producer”, “you”, “your”), who is registering for the service
                and has agreed to the terms of this Agreement, effective as of
                today’s date {formatted}.
              </p>
              <Separator className="bg-black" />
              <h1 className="font-bold">1. Scope</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The purpose of this Agreement is to grant exclusive,
                  non-transferable, irrevocable Content Licensing rights to{" "}
                  <strong>Enfinity Limited</strong> in order to legally perform
                  its services and comply with the policies in place that
                  moderate EnfiniShield and its use of sensitive third-party
                  tools, including but not limited to: YouTube Content ID,
                  Facebook Rights Manager, Snapchat Discovery, Microsoft feeds.
                  You acknowledge that without these rights, it is impossible
                  for us to legally perform our service. Our service in this
                  instance is to protect and monetize your catalog of content
                  through a combination of publishing and royalty claiming
                  techniques on various third-party platforms.
                </li>
                <li>
                  You still retain ownership of all your content, videos, and
                  intellectual property. However, upon registration submission,
                  you forfeit all rights to licensing the content submitted to
                  other companies in the future, and{" "}
                  <strong>Enfinity Limited</strong> will uphold its right as the
                  exclusive license holder in order to comply with usage
                  guideline policies mandated to us by third-party platforms;
                  otherwise, this service is impossible to perform.
                </li>
                <li>
                  By agreeing to the terms set forth, you are allowing{" "}
                  <strong>Enfinity Limited</strong> to exclusively manage and
                  monetize your video content internally and externally without
                  limitation.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">2. Content for Licensing</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The “Content” means the content produced and posted to your
                  social media channels that are being submitted upon
                  registration and submission (examples include YouTube,
                  Instagram, TikTok, Facebook, Douyin, Kuaishou, etc.), as well
                  as any other content that we and you agree in writing to
                  include in this Agreement from time to time.
                </li>
                <li>
                  You may deliver additional content to your point person at{" "}
                  <strong>EnfiniShield</strong> or by writing to
                  copyright@enfinity.com and attaching the content you desire to
                  submit as a file or via cloud storage with your provider of
                  choice, e.g. DropBox, OneDrive, etc.
                </li>
                <li>
                  At the time of this Agreement, the social video content has
                  been submitted by you to <strong>Enfinity Limited</strong> for
                  exclusive, non-transferrable, irrevocable content management
                  services; including but not limited to digital rights
                  management on YouTube and other platforms.
                </li>
                <li>
                  All content on the pages set forth on the onboarding
                  registration submission form has been submitted to{" "}
                  <strong>Enfinity Limited</strong> for exclusive,
                  non-transferrable, irrevocable licensing and will be subject
                  to review for its usage within EnfiniShield and its Network.
                </li>
              </ol>
              <p>
                Please note that not all content may be eligible, and that{" "}
                <strong>EnfiniShield’s</strong> team will review the submitted
                content herein to ensure third-party platform compliance.
              </p>
              <Separator className="bg-black" />
              <h1 className="font-bold">3. Fees and Payments</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  For the first one hundred USD generated in a given month,{" "}
                  <strong>Enfinity Limited</strong> will deduct a free services
                  fee equal to this amount because of its decision to absorb all
                  of the cost, labour, and risk in allowing you to freely
                  register to its services. Afterward, along with five percent
                  of the revenues generated as a content hosting fee (at the
                  moment, Dropbox Premium), <strong>Enfinity Limited</strong>{" "}
                  will automatically split the recouped revenue with the
                  Producer in accordance with the revenue-sharing rates of this
                  agreement, which are subject to change from time-to-time as
                  per the Company’s discretion and market conditions. For
                  YouTube partner ad-revenues generated by YouTube’s algorithmic
                  claiming, the baseline revenue-sharing tier after any
                  applicable service or administration fee is half to you and
                  half to <strong>Enfinity Limited</strong>, along with an
                  additional five percent to you (which is separate to the
                  existing share) if your content is selected, at our sole and
                  absolute discretion, for any special promotional or anchor
                  campaign on our supported platforms, which may change from
                  time to time.
                </li>
                <li>
                  Payments are sent out within 14-days of Facebook or AdSense
                  (if applicable per your content’s platform-specific
                  eligibility) disbursing the funds to us. If your content
                  generated revenue in January, this revenue will be paid on or
                  around February 28th.
                </li>
                <li>
                  You will be responsible for taxes and reporting your revenues
                  in your own respective country, and{" "}
                  <strong>Enfinity Limited</strong> will not be held liable in
                  any way in the event you neglect your duties to report
                  whatever ought to be reported.
                </li>
                <li>
                  In the event that ads are displayed on other channels
                  containing copyrighted content from multiple claimants, you
                  will be entitled to collect a share of the divided revenue
                  with other rights holders (e.g. Music Publishers) after
                  appropriate splits have taken place.
                </li>
                <li>
                  <strong>Enfinity Limited</strong> is not obligated to pay you
                  for any re-uploaded videos that fall outside of YouTube’s
                  content delivery requirements and criteria policies, including
                  content that falls below YouTube’s required minimum lengths
                  for algorithmic claiming.
                </li>
                <li>
                  The Network (<strong>Enfinity Limited / EnfiniShield</strong>)
                  will have no obligation to pay any amounts, and is permitted
                  to deduct or withhold any amounts owed, determined or
                  reasonably suspected by <strong>Enfinity Limited</strong>, in
                  its sole discretion, to have resulted from:
                  <br />
                  (a) Action Fraud, including without limitation through any
                  clicks originating from Talent’s IP addresses or computers
                  under Talent’s control, solicited by payment of money, false
                  representation or request for end users to click on Ads, or
                  <br />
                  (b) fraudulent, misleading or false activities or activities
                  that Enfinity Limited or its primary platforms, such as
                  YouTube and Facebook, believe to be fraudulent or misleading
                  or in violation of either of their respective terms of
                  service, guidelines, rules, or privacy policies.
                </li>
                <li>
                  <strong>Enfinity Limited</strong> reserves the right to
                  withhold or deduct any payments, pending its reasonable
                  investigation of any of the foregoing or any breach of this
                  Agreement.
                </li>
                <li>
                  Conflict resolution fees will be charged when{" "}
                  <strong>Enfinity Limited</strong> argues and handles a
                  disputed asset resolution on your behalf if you attempt to
                  work with multiple content claiming providers at once, thus
                  causing extra administrative work for EnfiniShield. If in any
                  given month there is one or more of these events, you will be
                  charged an additional five percent of the partner ad-revenue
                  generated in that given month.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">4. Contract Period</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The period of this Agreement will be for 24-months with
                  automatic renewals thereafter, unless you terminate this
                  Agreement with 90-days written notice prior to the renewal
                  date in form of legal writing to copyright@enfinity.com.
                </li>
                <li>
                  Should you decide to end this Agreement, we agree to stop
                  uploading/monetizing any new content you upload after the
                  termination date. You acknowledge and understand that
                  previously activated reference files will remain exclusively
                  licensed to us, as required by the third-party platforms we
                  partner with, making it possible to provide this service in
                  the first place.
                </li>
                <li>
                  If you choose to terminate this Agreement, we will ensure your
                  final payment is processed within 30 days of termination. By
                  ending your Agreement with <strong>Enfinity Limited</strong>{" "}
                  or any of our affiliates, you agree that no further payments
                  will be made to you after the termination date.
                </li>
                <li>
                  The content, video assets, and intellectual property that you
                  created, published, and/or generated prior to, and during the
                  tenure of your Partnership with the Company will remain
                  active, and{" "}
                  <strong>
                    Enfinity Limited’s exclusive content license (via
                    EnfiniShield)
                  </strong>{" "}
                  will remain non-transferable and active within its Content
                  Management Systems, including but not limited to publishing
                  and protection on YouTube, Facebook, Microsoft, and Snapchat
                  discovery. The exclusive license will survive the termination
                  of this Agreement and will remain non-transferable for all
                  content submitted upon registration and submission.
                </li>
                <li>
                  <strong>Enfinity Limited</strong> will retain its exclusive,
                  non-transferable content license rights after termination for
                  all content submitted prior to the effective date of your
                  termination. If you decide to work with another content
                  claiming Company, <strong>Enfinity Limited</strong> will keep
                  its right to manage the content internally and externally
                  within its systems, including but not limited to: Content ID,
                  Rights Manager, Microsoft Feeds, and tools of this nature.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">
                5. Enfinity Limited’s Rights and Licenses
              </h1>
              <p>
                You hereby grant to each of the following exclusive and
                non-transferable rights:
              </p>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  The exclusive right and license to use, reproduce, digitize,
                  encode, modify, monetize, re-format, transmit, re-broadcast,
                  repurpose the Content and collect revenues from the
                  protection, publishing, and management of the Content on
                  YouTube, Facebook, Snapchat, TikTok, Microsoft, and others
                  from time to time. You will be paid your share of the partner
                  ad-revenue on a monthly basis for as long as this Agreement is
                  active.
                </li>
                <li>
                  The exclusive right and license to administer content
                  claiming, including without limitation, Content ID claims, and
                  monetization services for the Content across third-party
                  platforms. If you have no existing presence on a promotional
                  platform (i.e. Snapchat, Microsoft, Facebook, YouTube), you
                  acknowledge and provide us the rights to publish, claim
                  against piracy, and monetize your library on such platforms
                  and pay you for doing so in accordance with the revenue shares
                  in section 3 as promotional royalties. You agree that the
                  Company withholds the right to not perform this service at any
                  time.
                </li>
                <li>
                  The ability to sub-license the content internally or
                  externally to third-party publishing partners for the purpose
                  of monetization and content protection benefit for you.
                </li>
                <li>
                  The ability to create an anchor account, or first account, on
                  platforms where your presence is not currently established in
                  order to prevent pirates from wrongfully uploading your
                  catalog and claiming first rights. The revenue share for this
                  is outlined as a promotional royalty in section 3.1. Royalties
                  will continue to be paid to us from anchor accounts
                  post-termination, and a buyout offer will be made to you for
                  sole ownership, typically at a multiple of twelve the gross
                  ARR we have generated on your behalf.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">6. Ownership/Clearances/Warranties</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>You retain full ownership of your Content.</li>
                <li>
                  You must have all the necessary rights and clearances in
                  connection with the Content, and you have the legal right to
                  grant the rights to us. By registering, digi-signing, and
                  submitting your Content and rights to{" "}
                  <strong>Enfinity Limited</strong>, you hereby absorb all legal
                  liability in the event of legal proceedings relating to the
                  Content you submitted for management.
                </li>
                <li>
                  You warrant and represent that the Content does not infringe
                  on the rights of any third party or violate third-party
                  platform rules, including YouTube’s Terms of Use.
                  Additionally, you agree to defend, indemnify and hold harmless{" "}
                  <strong>Enfinity Limited</strong> for any and all claims to
                  the contrary.
                </li>
              </ol>
              <Separator className="bg-black" />
              <h1 className="font-bold">7. Other Provisions</h1>
              <ol className="list-decimal list-outside space-y-2 pl-10">
                <li>
                  You agree to keep the terms of this Agreement confidential.
                </li>
                <li>
                  This Agreement is governed and construed according to{" "}
                  <strong>Hong Kong law</strong>, and by signing, you are
                  agreeing to submit to the jurisdiction of{" "}
                  <strong>Hong Kong</strong>.
                </li>
                <li>
                  You and <strong>Enfinity Limited</strong> waive all rights to
                  a jury trial, instead electing that the dispute be resolved by
                  a judge. Additionally, both parties agree that any and all
                  disputes or claims that have arisen or may arise between
                  either party (<strong>Enfinity Limited</strong> and You, the
                  "Producer"), including common law claims and those based in
                  contract, tort, fraud, misrepresentation or any other
                  equitable or legal theory, and relating in any way to this
                  website, its services or these terms will be resolved only by
                  and through confidential final and binding arbitration, rather
                  than in any court, except that You may only assert claims in
                  small claims court if your claims qualify and so long as the
                  matter remains in such court and advances only on an
                  individual (non-class, non-representative) basis.
                </li>
                <li>
                  Upon submission of acceptance of this User Agreement, I agree
                  that all information in this form is true and accurate. I also
                  agree that if I am under 18, my parent/guardian will sign this
                  User Agreement and absorb all legal liability for this User
                  Agreement.
                </li>
                <li>
                  You agree to, and are hereby bound to, our Terms of Service,
                  found here, which may be amended from time to time. Continued
                  use of our service is constituted as acceptance to such
                  amendments. These terms include the exclusive, explicit,
                  non-transferable content licensing rights to the content
                  contractually submitted by you to{" "}
                  <strong>Enfinity Limited</strong>. These rights remain even if
                  you terminate this Agreement, in accordance with section 4 of
                  this Agreement.
                </li>
                <li>
                  Electronic communication is a sufficient method to notify a
                  party.
                </li>
                <li>
                  By joining and accepting our registration forms, you agree as
                  follows: "
                  <span className="italic">
                    I understand I am granting a non-transferable, irrevocable,
                    fully exclusive license to all of the content submitted on
                    the social media pages I am submitting, and that{" "}
                    <strong>
                      Enfinity Limited (operating as EnfiniShield)
                    </strong>
                    , and any other of its authorized divisions without
                    limitation, may represent and manage this content on my
                    behalf without limitation.
                  </span>
                  "
                </li>
              </ol>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
